import api from '../../../../App/socket';

export const changeUserAvatar = (_id, avatar) => (
    api.send({
        api: 'module',
        module: 'UserManagement',
        classMethod: 'UpdateAvatar',
        options: {
            update: { avatar },
            where: { _id },
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/requests/user_profile_requests/change_user_avatar_request.js